import {types} from "mobx-state-tree";
import {SourceDtoModel} from "../../../pages/calendar/models/source.model";

export const TranslationModel = types.model( "TranslationModel", {
    key: types.identifier, value: types.string
} );

export const LeadConfigurationModel = types.model( 'LeadConfigurationModel', {
    locale: types.string,
    sourceExisting: types.maybeNull( SourceDtoModel ),
    sourceNew: types.maybeNull( SourceDtoModel ),
    source: types.maybeNull( SourceDtoModel ),
    theme: types.string,
    supportsBelfiusFinancing: types.optional( types.boolean, false ),
    translations: types.map( TranslationModel ),
    invalidDomains: types.array( types.string ),
    showAppointmentButton: types.optional( types.boolean, false ),
    appointmentMessage: types.optional( types.string, ''),
    stepOneNextButtonText: types.optional( types.string, ''),
    stepOneAppointmentButtonText: types.optional( types.string, '')
} );

export const FullContactModel = types.model( "FullContactModel", {
    reference: types.optional( types.string, '' ),
    firstName: types.string,
    lastName: types.string,
    email: types.string,
    street: types.string,
    number: types.string,
    numberAddition: types.string,
    postalCode: types.string,
    fullPostalCode: types.string,
    phoneNumber: types.string,
    vatNumber: types.string
} );

export const QuoteModel = types.model( "QuoteModel", {
    projectReference: types.optional( types.string, '' ),
    homeStatus: types.string,
    chosenPackage: types.maybeNull( types.string ),
    yearlyElectricityUsage: types.maybeNull( types.number ),
    solarQuantity: types.maybeNull( types.number ),
    batteryQuantity: types.maybeNull( types.number ),
} );

export const QuoteSimulationModel = types.model( "QuoteSimulationModel", {
    basePrice: types.maybeNull( types.number ),
    vat: types.maybeNull( types.number ),
    vatPercentage: types.maybeNull( types.number ),
    total: types.maybeNull( types.number ),
    flemishGovernmentBonus: types.maybeNull( types.number ),
    totalNetInvestment: types.maybeNull( types.number ),
    suggestionPack: types.maybeNull( types.string ),
    greenTax: types.maybeNull( types.number ),
    reloading: types.optional( types.boolean, false ),
    invalidPanelCount: types.optional( types.boolean, false )
} );

export const QuoteBelfiusModel = types.model( "QuoteBelfiusModel", {
    loanTerm: types.maybeNull( types.number ),
    periodicAmount: types.maybeNull( types.number ),
    yearlyRealRate: types.maybeNull( types.string ),
    interestRate: types.maybeNull( types.string ),
    totalAmount: types.maybeNull( types.number ),
    loanAmount: types.maybeNull( types.number ),
    currency: types.maybeNull( types.string ),
    links: types.maybeNull( types.map( types.string ) ),
    reloading: types.optional( types.boolean, true )
} )

export const QuotePdfGenerationModel = types.model( "QuotePdfGenerationModel", {
    generationState: types.enumeration( "GenerationState", ["NotYetGenerated", "Generating", "Generated"] ),
    downloadState: types.enumeration( "DownloadState", ["NotDownloaded", "Downloaded"] ),
    pdfIdentifier: types.maybeNull( types.string ),
    blobUrl: types.maybeNull( types.string )
} );

export const PackageModel = types.model( "PackageModel", {
    text: types.string, value: types.string, selected: types.boolean
} );

export const NoteModel = types.model( "NotesModel", {
    uploadedNoteFiles: types.boolean
} )
